<script setup lang="ts">
import { onMounted } from "vue";
import { useNotificationStore } from "@/stores/notification-store";
import { storeToRefs } from "pinia";
import NotificationList from "./NotificationList.vue";

const notificationStore = useNotificationStore();
const { unreadCount } = storeToRefs(notificationStore);

onMounted(async () => {
  // Load initial unread count
  await notificationStore.loadUnreadCount();

  // Initialize SignalR for real-time notifications
  await notificationStore.initializeSignalR();
});
</script>

<template>
  <li class="d-none d-xs-none d-sm-none d-md-inline-flex nav-item dropdown d-flex" style="position: static">
    <a
      class="nav-link ps-3 position-relative"
      href="#"
      role="button"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      data-bs-auto-close="outside"
    >
      <span class="d-block" style="height: 20px; width: 20px">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16px"
          height="16px"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-bell"
          style="height: 20px; width: 20px"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      </span>
      <span
        v-if="unreadCount > 0"
        class="position-absolute badge rounded-pill bg-primary notification-badge"
      >
        {{ unreadCount > 99 ? '99+' : unreadCount }}
        <span class="visually-hidden">unread messages</span>
      </span>
    </a>
    <div
      class="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border navbar-dropdown-caret"
      id="navbarDropdownNotification"
      aria-labelledby="navbarDropdownNotification"
    >
      <div class="card position-relative border-0">
        <NotificationList />
      </div>
    </div>
  </li>
</template>

<style scoped lang="scss">
.nav-item.dropdown .notification-dropdown-menu {
  min-width: 28rem;
  max-width: 28rem;
  position: absolute;
  right: 0;
  left: auto;
  transform: none;
}

.notification-badge {
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  font-size: 0.65rem;
  padding: 0.25em 0.5em;
  min-width: 1.25rem;
}

@media (max-width: 576px) {
  .notification-dropdown-menu {
    min-width: 20rem;
    max-width: 20rem;
  }
}
</style>
